import get from 'lodash/get';
import psHttp from '@patsnap/common-ps-http';
import {
    checkRangeSequenceToMsaApi,
    getSequenceDetailByUkApi,
    getSequenceBatchApi,
    submitSequenceApi,
    getSequenceResultApi,
    getAllHighLightKeysApi,
    getSequenceMatchResultApi,
    trackUserEventApi,
} from 'library-@/apis/life_science_api/life_science';
import { lifeScienceApiUrlPrefix } from 'library-@/config/constants';

const done = resp => get(resp, 'data.data', {});

export default class BioHelperService {
    constructor(patentId) {
        this.patentId = patentId;
    }

    exportSequence(pn, rangeStart, rangeEnd) {
        return psHttp({
            url: '/export/sequence',
            uuid: `/export/sequence/${this.patentId}`,
            data: {
                patentId: this.patentId,
                pn: pn,
                range_start: rangeStart,
                range_end: rangeEnd,
            },
            method: 'POST',
            cache: false,
        }).then(done);
    }

    getSequenceDetailByUk(bioUk, folderId) {
        return getSequenceDetailByUkApi(bioUk, this.patentId, folderId);
    }

    getSequenceDetailBySeqNo(seqNo, seqCode) {
        const patentId = this.patentId;
        const query = {
            patentId,
        };
        // 有些不好的数据有0
        if (typeof seqNo === 'number' || seqNo) {
            query.sequenceNo = `${seqNo}`;
        }
        if (seqCode) {
            query.sequence_number = seqCode;
        }

        const queryStr = new URLSearchParams(query).toString();
        return psHttp({
            url: `${lifeScienceApiUrlPrefix}/sequence?${queryStr}`,
            uuid: `/sequence?sequenceNo=${seqNo}&patentId=${patentId}&sequenceNumber=${seqCode}`,
            method: 'GET',
        }).then(res => {
            return get(res, 'data.data', {});
        });
    }

    // 检查专利中选择的序列范围是否合法
    checkRangeSequenceToMsa(params) {
        return checkRangeSequenceToMsaApi(params);
    }

    // 批量获取序列详情
    getSequenceBatch(params) {
        return getSequenceBatchApi(params);
    }

    submitSequence(params) {
        return submitSequenceApi(params, this.patentId);
    }

    async getSequenceResult(params) {
        return getSequenceResultApi(params, this.patentId);
    }

    async getSequenceMatchResult(params) {
        return getSequenceMatchResultApi(params, this.patentId);
    }

    async getAllHighLightKeys(params) {
        return getAllHighLightKeysApi(params, this.patentId);
    }

    async fetchDegenerateCode(sequenceId) {
        const degenerateCodes = await psHttp({
            url: `${lifeScienceApiUrlPrefix}/sequence/degenerate-code`,
            method: 'POST',
            data: [sequenceId],
        });
        const degenerateCode = get(
            degenerateCodes,
            `data.results.${sequenceId}`,
        );
        if (degenerateCode) {
            const map = {};
            const transferCode = [];
            const updateLocation = (index, degenerateCode, update) => {
                let location = map[index];
                if (!location) {
                    const rt = {
                        location: index,
                        degenerateCode,
                        commonDegenerate: false,
                    };

                    map[index] = rt;
                    transferCode.push(rt);
                    location = rt;
                }

                return update(location);
            };
            const allLocations =
              degenerateCode.degenerate_code_location || [];
            allLocations.forEach((location) => {
                updateLocation(location.index, location.degenerate_code, (loc) => {
                    Object.assign(loc, location);
                    return loc;
                });
            });
            const patents = degenerateCode.patent_replaces || [];
            patents.forEach(patent => {
                const positions = patent.replace_positions || [];
                positions.forEach(x => {
                    updateLocation(x.index, x.degenerate_code, location => {
                        // eslint-disable-next-line
                        const { replace_positions, ...rest } = patent;
                        Object.assign(rest, {
                            matched_code: x.matched_code,
                            replaces: x.replaces || [],
                            group: 0,
                        });
                        location.patentReplaces = (
                            location.patentReplaces || []
                        ).concat([rest]);
                        return location;
                    });
                });
            });
            const commons = degenerateCode.common_replaces || [];
            commons.forEach(x => {
                updateLocation(x.index, x.degenerate_code, location => {
                    if (Array.isArray(x.common_replaces) && x.common_replaces.length) {
                        location.commonReplaces = (location.commonReplaces || []).concat(x.common_replaces || []);
                    }
                    location.commonDegenerate = true;
                    if (Array.isArray(x.minus_common_replaces) && x.minus_common_replaces.length) {
                        location.minusCommonReplaces = (location.minusCommonReplaces || []).concat(
                            x.minus_common_replaces,
                        );
                    }
                    return location;
                });
            });
            return transferCode.sort((a, b) => a.location - b.location);
        }
    }

    async trackUserEvent(params) {
        return trackUserEventApi(params);
    }
}
